<template>
  <v-row no-gutters class="h100" style="position: relative">
    <template v-if="sortedProducts.length === 1">
      <v-col cols="12">
        <product-image
          :image="sortedProducts[0].product.image"
          :name="sortedProducts[0].product.name"
          :is-out-of-stock="disabled ? false : sortedProducts[0].product.qty.is_out_of_stock"
          :is-from-inventory="isProductFromInventory(sortedProducts[0])"
          :is-static="!!sortedProducts[0].is_static"
          hide-border-right
          :height="defaultImageHeight"
        />
      </v-col>
    </template>

    <template v-else-if="sortedProducts.length === 2 || sortedProducts.length === 4">
      <template v-for="(product, index) in sortedProducts">
        <v-col cols="6" :key="index">
          <product-image
            :image="product.product.image"
            :name="product.product.name"
            :is-out-of-stock="disabled ? false : product.product.qty.is_out_of_stock"
            :is-from-inventory="isProductFromInventory(product)"
            :is-static="!!product.is_static"
            :hide-border-right="(index + 1) % 2 === 0"
            :small-inventory-icon="showSmallInventoryIcon"
            :height="sortedProducts.length === 2 ? defaultImageHeight : alternativeImageHeight"
          />
        </v-col>
      </template>
    </template>

    <template v-else-if="sortedProducts.length === 3">
      <v-col cols="6">
        <product-image
          :image="sortedProducts[0].product.image"
          :name="sortedProducts[0].product.name"
          :is-from-inventory="isProductFromInventory(sortedProducts[0])"
          :is-out-of-stock="disabled ? false : sortedProducts[0].product.qty.is_out_of_stock"
          :is-static="!!sortedProducts[0].is_static"
          :height="defaultImageHeight"
        />
      </v-col>
      <v-col cols="6">
        <v-row no-gutters>
          <v-col cols="12">
            <product-image
              :image="sortedProducts[1].product.image"
              :name="sortedProducts[1].product.name"
              :is-from-inventory="isProductFromInventory(sortedProducts[1])"
              :is-out-of-stock="disabled ? false : sortedProducts[1].product.qty.is_out_of_stock"
              :is-static="!!sortedProducts[1].is_static"
              hide-border-right
              :small-inventory-icon="showSmallInventoryIcon"
              :height="alternativeImageHeight"
            />
          </v-col>
          <v-col cols="12">
            <product-image
              :image="sortedProducts[2].product.image"
              :name="sortedProducts[2].product.name"
              :is-from-inventory="isProductFromInventory(sortedProducts[2])"
              :is-out-of-stock="disabled ? false : sortedProducts[2].product.qty.is_out_of_stock"
              :is-static="!!sortedProducts[2].is_static"
              hide-border-right
              :small-inventory-icon="showSmallInventoryIcon"
              :height="alternativeImageHeight"
            />
          </v-col>
        </v-row>
      </v-col>
    </template>

    <template v-else-if="sortedProducts.length === 5">
      <v-col cols="6">
        <product-image
          :image="sortedProducts[0].product.image"
          :name="sortedProducts[0].product.name"
          :is-from-inventory="isProductFromInventory(sortedProducts[0])"
          :is-out-of-stock="disabled ? false : sortedProducts[0].product.qty.is_out_of_stock"
          :is-static="!!sortedProducts[0].is_static"
          :height="defaultImageHeight"
        />
      </v-col>
      <v-col cols="6">
        <v-row no-gutters>
          <template v-for="(product, index) in sortedProducts">
            <v-col cols="6" :key="index" v-if="index !== 0" >
              <product-image
                :image="product.product.image"
                :name="product.product.name"
                :is-from-inventory="isProductFromInventory(product)"
                :is-out-of-stock="disabled ? false : product.product.qty.is_out_of_stock"
                :is-static="!!product.is_static"
                :hide-border-right="(index + 1) === 3 || (index + 1) === 5"
                :height="alternativeImageHeight"
                :small-inventory-icon="showSmallInventoryIcon"
              />
            </v-col>
          </template>
        </v-row>
      </v-col>
    </template>

    <template v-else-if="sortedProducts.length === 6">
      <template v-for="(product, index) in sortedProducts">
        <v-col :cols="(index === 2 || index === 3) ? 6 : 3" :key="index">
          <product-image
            :image="product.product.image"
            :name="product.product.name"
            :is-from-inventory="isProductFromInventory(product)"
            :is-out-of-stock="disabled ? false : product.product.qty.is_out_of_stock"
            :is-static="!!product.is_static"
            :hide-border-right="(index + 1) % 3 === 0"
            :height="alternativeImageHeight"
            :small-inventory-icon="showSmallInventoryIcon"
          />
        </v-col>
      </template>
    </template>

    <template v-else>
      <template v-for="(product, index) in sortedProducts">
        <v-col
          :cols="3"
          :key="index"
          v-if="index < 7 || (sortedProducts.length <= 8 && index <= 8)"
        >
          <product-image
            :image="product.product.image"
            :name="product.product.name"
            :is-from-inventory="isProductFromInventory(product)"
            :is-out-of-stock="disabled ? false : product.product.qty.is_out_of_stock"
            :is-static="!!product.is_static"
            :hide-border-right="(index + 1) % 4 === 0"
            :height="alternativeImageHeight"
            :small-inventory-icon="showSmallInventoryIcon"
          />
        </v-col>
      </template>

      <empty-image-col v-if="sortedProducts.length === 7" />

      <multiple-products-col v-if="sortedProducts.length > 8">
        +{{ sortedProducts.length - 7 }}
      </multiple-products-col>
    </template>

    <div class="campaign-card-images--disabled" v-if="disabled">
      <div>DISABLED COLLECTION</div>
    </div>

  </v-row>
</template>

<script>
import ProductImage from './ProductImage.vue'
import EmptyImageCol from './common/EmptyImageCol.vue'
import MultipleProductsCol from './common/MultipleProductsCol.vue'
import { isProductFromInventory } from '@/utils/isProductFromInventory'

export default {
  name: 'TheCampaignCardImages',
  components: {
    ProductImage,
    EmptyImageCol,
    MultipleProductsCol
  },
  props: {
    products: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultImageHeight: {
      type: Number,
      required: false,
      default: 180
    },
    // TODO change name?
    alternativeImageHeight: {
      type: Number,
      required: false,
      default: 90
    },
    /**
     * Will show if a product is from the inventory
      */
    showProductsFromInventory: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Will force products to show that they are from inventory
      */
    showAllProductsFromInventory: {
      type: Boolean,
      required: false,
      default: false
    },
    showSmallInventoryIcon: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  computed: {
    sortedProducts () {
      return [...this.products].sort((a, b) => (b?.is_static ? 1 : 0) - (a?.is_static ? 1 : 0))
    }
  },
  methods: {
    isProductFromInventory (product) {
      const { showProductsFromInventory, showAllProductsFromInventory } = this

      if (showAllProductsFromInventory) return true

      if (showProductsFromInventory) {
        return isProductFromInventory(product)
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.campaign-card-images--disabled {
  position: relative;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  background-color: rgba(255, 255, 255, 0.4);

  & > div {
    background: hsla(358, 100%, 68%, 1);
    padding: 4px 8px;
    font-family: 'Lato-Bold', sans-serif !important;
    font-size: 10px;
    line-height: 14px;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
}
</style>
